// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BulkFollowListModal-cls1___3674d1c005b2fc83817{/*!*/}.BulkFollowListModal-cls2__d915ff4e44983ee40800{height:400px;overflow-y:scroll;margin-bottom:20px;padding:0 16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "BulkFollowListModal-cls1___3674d1c005b2fc83817",
	"cls2": "BulkFollowListModal-cls2__d915ff4e44983ee40800 BulkFollowListModal-cls1___3674d1c005b2fc83817"
};
export default ___CSS_LOADER_EXPORT___;
